import { TagFragment } from '~/graphql/fragments/fragments'

export const querySite = /* GraphQL */ `
  ${TagFragment}

  query SiteQuery(
    $locale: SiteLocale
    $first: IntType = 100
    $publishTranslation: BooleanType = true
  ) {
    _site {
      globalSeo {
        siteName
        titleSuffix
      }
      favicon {
        url
      }
      faviconMetaTags {
        ...TagFragment
      }
      locales
    }
    allMenuCtas(
      first: $first
      locale: $locale
      filter: { publishTranslation: { eq: $publishTranslation } }
    ) {
      id
      title
      reference {
        _modelApiKey
        slug
      }
      externalLink
      primary
      publishTranslation
    }
    allMenuItems(
      first: $first
      locale: $locale
      filter: { publishTranslation: { eq: $publishTranslation } }
    ) {
      id
      children {
        id
        title
        description
        parent {
          id
        }
        reference {
          _modelApiKey
          slug
        }
        externalLink
        publishTranslation
      }
      externalLink
      parent {
        id
      }
      reference {
        __typename
        _modelApiKey
        slug
      }
      title
      description
      publishTranslation
    }
    allFooterLinks(locale: $locale, filter: { publishTranslation: { eq: $publishTranslation } }) {
      externalLink
      reference {
        _modelApiKey
        slug
      }
      title
      publishTranslation
    }
    allSocialLinks(locale: $locale) {
      title
      url
    }
    allUsefulLinks(locale: $locale) {
      title
      url
    }
    allLocationCategories(locale: $locale) {
      __typename
      id
      name
      slug
    }
    allCategories(locale: $locale) {
      __typename
      id
      name
      slug
    }
    allCountries(locale: $locale) {
      __typename
      id
      name
      locale
      slug
    }
    _allProjectsMeta {
      count
    }
    _allLocationsMeta {
      count
    }
  }
`
